
export interface Field{
    aggFunc?: string;
    pinned?: boolean | "left" | "right";
    formulaIcon?:string|null;
    validationError?: string|null;
    maxWidth?: number|null;
    columnName?:string|null;
    columnDesc?:string|null;
    headerName?:string|null;
    hide?:boolean|null;
    type?:EnumColumnType|null;
    order?:number|null;
    width?:number|null;
    sort?:string|null;
    sortable?:boolean|null;
    resizable?:boolean|null;
    headerTooltip?:string|null;
    filter?:boolean|null;
    format?:string|null;
    isCurrency?:boolean|null;
    cellStyle?:string|null;
  }
  

  export enum EnumColumnType {
      Text = 1,
      Date = 2,
      DateTime = 3,
      Number = 4,
      Integer = 5,
      Selection = 6,
      Icon = 7
  }